<div [class]="productStringID" style="top: 0px; left: 0px; width: 100%; height: 100%; position: fixed"><canvas id="confetti"></canvas></div>
@if (!splash.modalBackground || !splash.headerText) {
  <button type="button" ngbAutofocus class="fs-close-btn right border-0 bg-transparent p-0" (click)="close()" data-cy="close-success-splash-button" aria-label="close" id="close-success-splash-button">
    <fa-icon icon="times-circle" class="circle-icon-btn" aria-hidden="true"></fa-icon>
  </button>
}
@if (splash.modalBackground && splash.headerText) {
  <div class="modal-header">
    <h1 class="modal-title">{{ splash.headerText }}</h1>
    <button ngbAutofocus class="close" aria-label="Close" (click)="close()" data-cy="close-success-splash-button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
}

<div class="modal-body clear">
  <div class="product-success-splash-content" data-cy="product-success-splash" [innerHTML]="splash.description | safe: 'html'"></div>
  @if (shouldShowDownloads && splash.downloadsProductId && !productSnapshot) {
    <div class="m-t-30 text-center">
      <fa-icon icon="spinner" animation="spin"></fa-icon>
      Loading downloads...
    </div>
  }
  @if (productSnapshot?.downloads?.installers) {
    <h4 class="section-header m-t-30 justify-content-center">{{ "download.downloads" | translate }}</h4>
    @if (productSnapshot?.downloads) {
      <myp-installer-buttons [centered]="true" [isSideBar]="false" [downloads]="productSnapshot.downloads" [product]="productSnapshot.product"></myp-installer-buttons>
    }
  }
  <br />
  <br />
  <div class="text-center"><button class="link" id="close">Close</button></div>
</div>
